module.exports = __webpack_public_path__ + "img/products-5.08da5bf8.jpg";